
<template>
    <div class="page">
        <div class="contract-desc" v-if="viewStatus === 'wait' && openType !== 'preview'">{{$t('sign_contract.detail3')}}</div>
        <div class="contract-section">
            <!-- Wellcee 无中介-线上租赁合同 -->
            <div class="section-title border">{{$t('sign_contract.detail4')}}</div> 
            <div class="section-form">
                <!-- 本合同由以下三方共同确认生效： -->
                <div>{{$t('sign_contract.detail5')}}</div>
                <br>
                <div>
                    <div class="section-form-item">
                        <!-- 出租方（甲方）： -->
                        <span class="section-form-label">{{$t('sign_contract.detail6')}}</span>
                        <span class="section-form-value">{{info.landlordContractInfo.name}}</span>
                    </div>
                    <div class="section-form-item">
                        <!-- 证件号： -->
                        <span class="section-form-label">{{$t('sign_contract.detail8')}}</span>
                        <span class="section-form-value">{{info.landlordContractInfo.idCard}}</span>
                    </div>
                    <div class="section-form-item">
                        <!-- 联系方式： -->
                        <span class="section-form-label">{{$t('sign_contract.detail9')}}</span>
                        <span class="section-form-value">{{info.landlordContractInfo.phone}}</span>
                    </div>
                </div>
                <br>
                <div>
                    <div class="section-form-item">
                        <!-- 承租方（乙方）： -->
                        <span class="section-form-label">{{$t('sign_contract.detail7')}}</span>
                        <span class="section-form-value">{{info.tenantContractInfo.name}}</span>
                    </div>
                    <div class="section-form-item">
                        <!-- 证件号： -->
                        <span class="section-form-label">{{$t('sign_contract.detail8')}}</span>
                        <span class="section-form-value">{{info.tenantContractInfo.idCard}}</span>
                    </div>
                    <div class="section-form-item">
                        <!-- 联系方式： -->
                        <span class="section-form-label">{{$t('sign_contract.detail9')}}</span>
                        <span class="section-form-value">{{info.tenantContractInfo.phone}}</span>
                    </div>
                </div>
                <br>
                <!-- 平台方（丙方）：上海良孝科技有限公司（Wellcee） -->
                <div>{{$t('sign_contract.detail10')}}</div>
                <!-- 甲方与乙方通过 Wellcee 平台达成租赁意向，并自愿采用线上方式签署本合同。双方确认：本合同经线上确认后，与线下手写签名或盖章具备同等法律效力。 -->
                <div>{{$t('sign_contract.detail11')}}</div>
                <br>
                <br>
                <!-- 第一条 房屋信息与租赁期限 -->
                <div class="section-form-title">{{$t('sign_contract.detail12')}}</div>
                <br>
                <ol>
                    <li class="section-form-item">
                        <!-- 房屋详细地址： -->
                        <span class="section-form-label">{{$t('sign_contract.detail13')}}</span>
                        <span class="section-form-value">{{info.address}}</span>
                    </li>
                    <li>
                        <!-- 租赁期限：自 -->
                        <span class="section-form-label">{{$t('sign_contract.detail14')}} </span>
                        <span class="section-form-value">{{info.startDate}}</span>
                        <!-- 起至 -->
                        <span class="section-form-label"> {{$t('sign_contract.detail15')}} </span>
                        <span class="section-form-value">{{info.endDate}}</span>
                        <!-- 止。 -->
                        <span class="section-form-label">{{$t('sign_contract.detail16')}}</span>
                    </li>
                </ol>
                <br>
                <br>
                <!-- 第二条 租金与支付方式 -->
                <div class="section-form-title">{{$t('sign_contract.detail17')}}</div>
                <br>
                <ol>
                    <li class="section-form-item">
                        <!-- 双方确认 月租金为人民币 -->
                        <span class="section-form-label">{{$t('sign_contract.detail18')}} </span>
                        <span class="section-form-value">{{info.monthlyRent}}</span>
                        <!-- 元/月（不含水电气费、物业费及其他杂费）。 -->
                        <span class="section-form-label"> {{$t('sign_contract.detail19')}}</span>
                    </li>
                    <li class="section-form-item">
                        <!-- 租金由乙方根据事先和房东的约定按 -->
                        <span class="section-form-label">{{$t('sign_contract.detail20')}} </span>
                        <!-- 月度 -->
                        <span class="section-form-value" v-if="info.paymentCycle === '1'">{{$t('sign_contract.detail21')}}</span>
                        <!-- 季度 -->
                        <span class="section-form-value" v-if="info.paymentCycle === '2'">{{$t('sign_contract.detail22')}}</span>
                        <!-- 年付 -->
                        <span class="section-form-value" v-if="info.paymentCycle === '3'">{{$t('sign_contract.detail23')}}</span>
                        <!-- 支付。逾期可能影响合同继续履行，由责任方承担后果。 -->
                        <span class="section-form-label"> {{$t('sign_contract.detail24')}}</span>
                    </li>
                    <li class="section-form-item">
                        <!-- 维修费、物业费及其他费用的承担方式，以甲、乙双方协议为准。 -->
                        <span class="section-form-label">{{$t('sign_contract.detail25')}}</span>
                    </li>
                </ol>
                <br>
                <br>
                <!-- 第三条 押金托管规则 -->
                <div class="section-form-title">{{$t('sign_contract.detail26')}}</div>
                <br>
                <div>
                    <!-- 押金托管 -->
                    <div class="section-form-title-second">{{$t('sign_contract.detail27')}}</div>
                    <div class="section-form-item">
                        <!-- 乙方签约时需支付押金人民币 -->
                        <span class="section-form-label">{{$t('sign_contract.detail28')}} </span>
                        <span class="section-form-value">{{info.depositAmount}}</span>
                        <!-- 元，由 Wellcee 平台进行阶段性托管；平台仅提供技术托管，不承担押金责任认定。 -->
                        <span class="section-form-label"> {{$t('sign_contract.detail29')}}</span>
                    </div>
                    <!-- 押金可提现时间 -->
                    <div class="section-form-title-second">{{$t('sign_contract.detail30')}}</div>
                    <div class="section-form-item">
                        <!-- 乙方入住满 15 天后，甲方可在平台申请提取押金。入住 15 天内押金作为纠纷保障，未经双方确认不予提前提取。 -->
                        <span class="section-form-label">{{$t('sign_contract.detail31')}}</span>
                    </div>
                    <!-- 押金依据资料 -->
                    <div class="section-form-title-second">{{$t('sign_contract.detail32')}}</div>
                    <div class="section-form-item">
                        <!-- 入住 15 天内的押金纠纷，以以下资料为依据：入住时的房屋现状照片、补充协议、平台聊天记录等（资料缺失或模糊，将影响相关协调支持。） -->
                        <span class="section-form-label">{{$t('sign_contract.detail33')}}</span>
                    </div>
                    <!-- 争议处理 -->
                    <div class="section-form-title-second">{{$t('sign_contract.detail34')}}</div>
                    <div class="section-form-item">
                        <!-- 若双方对押金金额有异议，平台可协助沟通，但平台 -->
                        <span class="section-form-label">{{$t('sign_contract.detail35')}}</span>
                        <!-- 不对损坏责任或扣款合理性作出判断； -->
                        <span class="section-form-label blod">{{$t('sign_contract.detail36')}}</span>
                        <!-- 协商不成的，双方可通过房屋所在地法院或仲裁机构解决。 -->
                        <div class="section-form-label">{{$t('sign_contract.detail37')}}</div>
                    </div>
                </div>
                <br>
                <br>
                <!-- 第四条 甲方（出租方）义务 -->
                <div class="section-form-title">{{$t('sign_contract.detail38')}}</div>
                <br>
                <ol>
                    <!-- 保证房屋具备合法出租权，不存在查封、抵押、腾退风险。 -->
                    <li class="section-form-item">{{$t('sign_contract.detail39')}}</li>
                    <!-- 保证房屋状况与租房信息一致；如存在虚假描述，乙方可解除合同，甲方需退还所有费用。 -->
                    <li class="section-form-item">{{$t('sign_contract.detail40')}}</li>
                    <!-- 自然损耗或设备质量问题由甲方负责维修。 -->
                    <li class="section-form-item">{{$t('sign_contract.detail41')}}</li>
                    <!-- 不得在租期内无正当理由提前收回房屋。 -->
                    <li class="section-form-item">{{$t('sign_contract.detail42')}}</li>
                    <!-- 需按约定时间交付可正常居住的房屋。 -->
                    <li class="section-form-item">{{$t('sign_contract.detail43')}}</li>
                </ol>
                <br>
                <br>
                <!-- 第五条 乙方（承租方）义务 -->
                <div class="section-form-title">{{$t('sign_contract.detail44')}}</div>
                <br>
                <ol>
                    <!-- 按时支付租金，遵守正常居住使用范围。 -->
                    <li class="section-form-item">{{$t('sign_contract.detail45')}}</li>
                    <!-- 因乙方人为原因导致的设施损坏，需承担维修或赔偿费用。 -->
                    <li class="section-form-item">{{$t('sign_contract.detail46')}}</li>
                    <!-- 不得擅自转租、群租、改变房屋用途或存放危险品。 -->
                    <li class="section-form-item">{{$t('sign_contract.detail47')}}</li>
                    <!-- 需遵守小区物业管理规定，文明居住。 -->
                    <li class="section-form-item">{{$t('sign_contract.detail48')}}</li>
                    <!-- <li class="section-form-item">退租前需按平台要求上传完整退房照片。</li> -->
                </ol>
                <br>
                <br>
                <!-- 第六条 身份验证与风控要求 -->
                <div class="section-form-title">{{$t('sign_contract.detail50')}}</div>
                <br>
                <ol>
                    <!-- 大陆用户需完成人脸识别；港澳台及外国用户需上传证件照及手持证件照。 -->
                    <li class="section-form-item">{{$t('sign_contract.detail51')}}</li>
                    <!-- 若任一方提交虚假资料、冒用他人身份，平台有权终止合同流程，合同自动失效，由责任方承担全部后果。 -->
                    <li class="section-form-item">{{$t('sign_contract.detail52')}}</li>
                    <!-- 平台进行的是 技术性校验，不构成对身份真实性的法律鉴定。 -->
                    <li class="section-form-item">{{$t('sign_contract.detail53')}}</li>
                </ol>
                <br>
                <br>
                <!-- 第七条 合同附件与补充协议 -->
                <div class="section-form-title">{{$t('sign_contract.detail54')}}</div>
                <br>
                <ol>
                    <!-- 房源出租方（甲方）可上传的附件，包括但不限于：补充协议、房屋现状照片、家具电器清单、交割清单、入住须知等。 -->
                    <li class="section-form-item">{{$t('sign_contract.detail55')}}</li>
                    <!-- 所有上传附件均视为本合同组成部分，与本合同具有同等效力。 -->
                    <li class="section-form-item">{{$t('sign_contract.detail56')}}</li>
                    <!-- 若附件内容与主合同冲突，以双方确认的最新附件为准。 -->
                    <li class="section-form-item">{{$t('sign_contract.detail57')}}</li>
                </ol>
                <br>
                <br>
                <!-- 第八条 提前终止合同 -->
                <div class="section-form-title">{{$t('sign_contract.detail58')}}</div>
                <br>
                <div>
                    <!-- 乙方提前退租： -->
                    <div class="section-form-title-second">{{$t('sign_contract.detail59')}}</div>
                    <ol>
                        <!-- 乙方提前退租应至少提前 30 日通知甲方。 -->
                        <li class="section-form-item">{{$t('sign_contract.detail60')}}</li>
                        <!-- 若双方无特别约定，乙方提前退租，甲方可要求乙方支付 不超过 1 个月租金 的补偿。 -->
                        <li class="section-form-item">{{$t('sign_contract.detail61')}}</li>
                        <!-- 若因房屋质量问题、安全隐患、房源不符、甲方未按约交付可居住房屋等原因导致乙方无法入住，乙方可无责解除合同，甲方应退还乙方已支付的全部款项。 -->
                        <li class="section-form-item">{{$t('sign_contract.detail62')}}</li>
                        <!-- 乙方因个人原因在入住日前取消已确认订单的，视为单方违约。甲方可向乙方收取“锁房补偿费”，其计算方式为： -->
                        <li class="section-form-item">{{$t('sign_contract.detail63')}}</li>
                    </ol>
                    <ul>
                        <li class="section-form-item">
                            <!-- 锁房天数： -->
                            <span class="blod">{{$t('sign_contract.detail64')}}</span>
                            <!-- 自合同确认日起至乙方提出取消之日止； -->
                            <span>{{$t('sign_contract.detail65')}}</span>
                        </li>
                        <li class="section-form-item">
                            <!-- 补偿金额： -->
                            <span class="blod">{{$t('sign_contract.detail66')}}</span>
                            <!-- 按每日租金 × 锁房天数计算，最高不超过 1 个月租金。 -->
                            <span>{{$t('sign_contract.detail67')}}</span>
                        </li>
                        <li class="section-form-item">
                            <!-- 补偿用于覆盖甲方因房源暂停出租产生的实际损失。 -->
                            {{$t('sign_contract.detail68')}}
                        </li>
                    </ul>
                    <br>
                    <br>
                    <!-- 甲方提前终止： -->
                    <div class="section-form-title-second">{{$t('sign_contract.detail69')}}</div>
                    <ol>
                        <!-- 甲方提前终止的，应退还乙方所有未使用租金及押金。 -->
                        <li class="section-form-item">{{$t('sign_contract.detail70')}}</li>
                        <!-- 如甲方无正当理由提前终止或取消预定，应向乙方支付补偿。若未另行约定，乙方最多可要求 1 个月租金作为补偿 -->
                        <li class="section-form-item blod">{{$t('sign_contract.detail71')}}</li>
                        <!-- 因政府强制腾退或出现严重安全隐患等无法继续出租的，甲方可无责解除合同，但需提供相关证明，并退还乙方未使用款项。 -->
                        <li class="section-form-item">{{$t('sign_contract.detail72')}}</li>
                    </ol>
                </div>
                <br>
                <br>
                <!-- 第九条 不可抗力与政策变化 -->
                <div class="section-form-title">{{$t('sign_contract.detail73')}}</div>
                <br>
                <!-- 因自然灾害、疫情管控、政府政策调整等不可抗力事件导致无法继续履行合同的，双方应协商处理。平台不承担因此造成的损失。 -->
                <div>{{$t('sign_contract.detail74')}}</div>
                <br>
                <br>
                <!-- 第十条 争议与调解 -->
                <div class="section-form-title">{{$t('sign_contract.detail75')}}</div>
                <br>
                <ol>
                    <!-- 争议应由双方先行在平台协商解决。 -->
                    <li class="section-form-item">{{$t('sign_contract.detail76')}}</li>
                    <!-- 调解无果，任一方可向房屋所在地法院/仲裁机构申请处理。 -->
                    <li class="section-form-item">{{$t('sign_contract.detail77')}}</li>
                </ol>
                <br>
                <br>
                <!-- 第十一条 平台免责条款 -->
                <div class="section-form-title">{{$t('sign_contract.detail78')}}</div>
                <br>
                <div>
                    <ol>
                        <li class="section-form-item">
                            <!-- 平台角色 -->
                            <div  class="section-form-title-second">{{$t('sign_contract.detail79')}}</div>
                            <!-- Wellcee（丙方）仅提供信息发布、线上签约及阶段性押金托管等技术服务，不参与租赁关系的成立、履行、变更或终止，也非合同当事人。 -->
                            <div>{{$t('sign_contract.detail80')}}</div>
                        </li>
                        <li class="section-form-item">
                            <!-- 信息真实性责任 -->
                            <div  class="section-form-title-second">{{$t('sign_contract.detail81')}}</div>
                            <!-- 房源信息、身份资料、证明文件及附件均由甲乙双方上传并确认，其真实性、合法性和完整性由上传方自行承担。平台不负实质审查义务，不保证房源可出租性、权属合法性或资料真实有效。 -->
                            <div>{{$t('sign_contract.detail82')}}</div>
                        </li>
                        <li class="section-form-item">
                            <!-- 线下履约责任 -->
                            <div  class="section-form-title-second">{{$t('sign_contract.detail83')}}</div>
                            <!-- 房屋交付、维修、水电物业结算、邻里纠纷等属双方线下履约范畴，由双方自行承担责任；平台不承担保证或连带责任。 -->
                            <div>{{$t('sign_contract.detail84')}}</div>
                        </li>
                        <li class="section-form-item">
                            <!-- 押金争议边界 -->
                            <div  class="section-form-title-second">{{$t('sign_contract.detail85')}}</div>
                            <!-- 平台对押金仅提供技术托管，不对扣除项目、损坏责任或费用合理性作判断。押金争议由双方协商解决；平台调解为协助性质，无强制力，调解失败应依法处理。 -->
                            <div>{{$t('sign_contract.detail86')}}</div>
                        </li>
                        <li class="section-form-item">
                            <!-- 免责范围 -->
                            <div  class="section-form-title-second">{{$t('sign_contract.detail87')}}</div>
                            <!-- 下列情形造成的损失、费用或纠纷，平台不承担责任： -->
                            <div>{{$t('sign_contract.detail88')}}</div>
                            <div class="section-form-item">
                                <!-- （1）用户提供虚假、不完整或失效资料； -->
                                <div class="section-form-label">{{$t('sign_contract.detail89')}}</div>
                                <!-- （2）线下信息不一致或更新不及时； -->
                                <div class="section-form-label">{{$t('sign_contract.detail90')}}</div>
                                <!-- （3）因网络、设备故障或不可抗力导致签约延迟或失败； -->
                                <div class="section-form-label">{{$t('sign_contract.detail91')}}</div>
                                <!-- （4）任何间接损失、预期利益损失或惩罚性赔偿。 -->
                                <div class="section-form-label">{{$t('sign_contract.detail92')}}</div>
                            </div>
                        </li>
                    </ol>
                </div>
                <br>
                <br>
                <!-- 第十二条 信息保护 -->
                <div class="section-form-title">{{$t('sign_contract.detail93')}}</div>
                <br>
                <!-- 平台将对用户身份信息、人脸识别数据、聊天记录等隐私数据进行加密存储，仅用于租赁相关目的。 -->
                <div>{{$t('sign_contract.detail94')}}</div>
                <br>
                <br>
                <!-- 第十三条 合同生效 -->
                <div class="section-form-title">{{$t('sign_contract.detail95')}}</div>
                <br>
                <!-- 甲乙双方通过 Wellcee 平台进行确认即视为签署完成。本合同即时生效。 -->
                <div>{{$t('sign_contract.detail96')}}</div>
                <br>
                <br>
                <!-- 第十四条 合同语言 -->
                <div class="section-form-title">{{$t('sign_contract.detail97')}}</div>
                <br>
                <!-- 本合同包含中文和英文版本，两种语言版本均具有同等法律效力。如不同语言版本存在理解差异或冲突，以中文版本为准。 -->
                <div>{{$t('sign_contract.detail98')}}</div>
                <br>
                <br>
                <!-- 签署确认 -->
                <div class="section-form-title">{{$t('sign_contract.detail99')}}</div>
                <br>
                <div>
                    <div class="section-form-item">
                        <!-- 甲方（出租方）： -->
                        <span class="section-form-label">{{$t('sign_contract.detail100')}}</span>
                        <span class="section-form-value-sign" v-show="info.landlordContractInfo.name && viewStatus === 'signed'">{{info.landlordContractInfo.name}}</span>
                    </div>
                    <div class="section-form-item">
                        <!-- 签署日期： -->
                        <span class="section-form-label">{{$t('sign_contract.detail103')}}</span>
                        <span class="section-form-value">{{info.tenantSignDate}}</span>
                    </div>
                    <br>
                    <div class="section-form-item">
                        <!-- 乙方（承租方）： -->
                        <span class="section-form-label">{{$t('sign_contract.detail101')}}</span>
                        <span class="section-form-value-sign" v-show="info.tenantContractInfo.name && viewStatus === 'signed'">{{info.tenantContractInfo.name}}</span>
                    </div>
                    <div class="section-form-item">
                        <!-- 签署日期： -->
                        <span class="section-form-label">{{$t('sign_contract.detail103')}}</span>
                        <span class="section-form-value">{{info.tenantSignDate}}</span>
                    </div>
                    <br>
                    <div class="section-form-item">
                        <!-- 丙方（Wellcee）： -->
                        <span class="section-form-label">{{$t('sign_contract.detail102')}}</span>
                        <!-- 上海良孝科技有限公司 -->
                        <span class="section-form-label">{{$t('sign_contract.detail104')}}</span>
                    </div>
                    <div class="section-form-item">
                        <!-- 签署日期： -->
                        <span class="section-form-label">{{$t('sign_contract.detail103')}}</span>
                        <span class="section-form-value">{{info.tenantSignDate}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="viewStatus === 'signed'">
            <div class="contract-section">
                <!-- 补充协议 -->
                <div class="section-title border">{{$t('sign_contract.detail105')}}</div>
                <div class="contract-added">{{info.suppAgrees}}</div>
            </div>
            <div class="contract-section" v-if="info.attachment.length > 0">
                <!-- 附件 -->
                <div class="section-title border">{{$t('sign_contract.detail106')}}</div>
                <img class="attachment" v-for="(item, index) in info.attachment" :key="item" :src="item" alt="" @click="previewImg(item, index)">
            </div>
            <div class="contract-section" v-if="info.landlordAuthImage || info.landlordHoldImage">
                <!-- 房东实名信息 -->
                <div class="section-title border">{{$t('sign_contract.detail107')}}</div>
                <img class="attachment" :src="info.landlordAuthImage" alt="" @click="previewImg(info.landlordAuthImage)">
                <img class="attachment" :src="info.landlordHoldImage" alt="" @click="previewImg(info.landlordHoldImage)">
            </div>
            <div class="contract-section" v-if="info.tenantAuthImage || info.tenantHoldImage">
                <!-- 租客实名信息 -->
                <div class="section-title border">{{$t('sign_contract.detail108')}}</div>
                <img class="attachment" :src="info.tenantAuthImage" alt="" @click="previewImg(info.tenantAuthImage)">
                <img class="attachment" :src="info.tenantHoldImage" alt="" @click="previewImg(info.tenantHoldImage)">
            </div>
        </div>
    </div>
</template>
<script>
import {useRoute} from "vue-router";
import api from "@/api/index";
import { Toast } from 'vant';
export default {
    data() {
        return {
            id: null,
            lang: 'zh',
            info: {
                name: '',
                address: '',
                depositAmount: '',
                monthlyRent: '',
                startDate: '',
                endDate: '',
                landlordContractInfo: {},
                tenantContractInfo: {},
                attachment: [],
                suppAgrees: '',
                paymentCycle: '1',
                status: false,
            },
            openType: undefined
        };
    },
    computed: {
        viewStatus() {
            // return [2,3].includes(this.info.status) ? 'wait' : [4,5,6].includes(this.info.status) ? 'signed' : false;
            return this.openType || [4,5,6].includes(this.info.status) ? 'signed' : 'wait';
        }
    },
    mounted() {
        this.initThemeAndLang();
        this.getSignContractInfo()
    },
    methods: {
        initThemeAndLang() {
            const route = useRoute();
            this.lang = ['zh', 'en'].includes(route.query.lang) ? route.query.lang : 'zh';
            this.id = route.query.id || null;
            if (route.query.theme == 'dark') {
                document.documentElement.setAttribute('data-theme', 'dark');
            }
            if (route.query.lang && ['zh', 'en', 'tw'].includes(route.query.lang)) {
                this.$i18n.locale = route.query.lang
            }
            if(route.query.openType === 'preview') {
                this.openType = 'preview';
                document.body.style.zoom = 2;
            }
            document.title = "合同";
        },
        // 监听滚动到底部
        handleScroll() {
            const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
            const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            const clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
            if (scrollTop + clientHeight >= scrollHeight) {
                console.log("滚动到底部了");
                // 发送postMessage给父页面
                window.parent.postMessage('scroll-to-bottom', '*');
            }
            
        },
        getSignContractInfo(){
            Toast.loading({
                // message: '加载中...',
                forbidClick: true,
                duration: 0
            });
            let form = {
                id: this.id,
            }
            if(this.openType === 'preview') {
                form.unencrypt = true;
            }
            api.sign.getSignContractInfo(form).then(res=>{
                console.log("合同信息", res);
                // res.data.attachment = [...res.data.attachment, ...res.data.attachment]
                this.info = res.data;
                if([4,5,6].includes(res.data.status)) {
                    document.title = this.$t('sign_contract.detail2'); // 查看合同
                }else {
                    document.title = this.$t('sign_contract.detail1'); // 确认合同
                }
                window.addEventListener('scroll', this.handleScroll);
                Toast.clear();
            }).catch(err=>{
                console.log("获取合同信息失败", err);
                Toast.clear();
            })
        },
        previewImg(url, index=0) {
            const images = url ? [url] : this.info.attachment;
            this.$hevueImgPreview({
                imgList: images,
                nowImgIndex: index,
                // controlBar: ['zoomOut', 'zoomIn', 'rotateLeft', 'rotateRight', 'prev', 'next', 'download'],
            });
        }
    }
}
</script>
<style scoped>

ol, ul {
    list-style: initial;
    padding: 0;
    padding-left: 1.3em;
}
ol {
    list-style: decimal;
    /* list-style-position: inside; */
}
.page {
    background: var(--color_bg_page);
    padding: 15px;
    font-size: 0;
    line-height: initial;
}
.contract-desc {
    color: var(--color_text_tertiary);
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: "PingFang SC";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}
.contract-section {
    display: flex;
    width: 100%;
    box-sizing: border-box;
    padding: 20px 15px;
    flex-direction: column;
    border-radius: 10px;
    background: var(--color_bg_card);
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.06);
    margin-top: 10px;
}
.contract-section:last-child {
    margin-bottom: 110px;
}
.section-title {
    color: var(--color_text_primary);
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: "PingFang SC";
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    padding-bottom: 15px;
    
}
.section-title.border {
    border-bottom: 1px solid var(--color_border);
    margin-bottom: 15px;
}
.section-form {
    color: var(--color_text_primary);
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: "PingFang SC";
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}
.bottom-gap {
    margin-bottom: 17px;
}
.section-form-item {
    color: var(--color_text_primary);
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: "PingFang SC";
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}
.section-form-value {
    color: var(--color_text_primary);
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: "PingFang SC";
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: auto;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
    text-underline-position: from-font;
}
.section-form-value-sign {
    padding: 0px 6px;
    border-radius: 6px;
    border: 2px solid #F92E2E;
    color: #F92E2E;
    text-align: center;
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: "PingFang SC";
    font-size: 13px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
}
.section-form-title {
    color: var(--color_text_primary);
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: "PingFang SC";
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
}
.section-form-title-second {
    font-weight: 600;
}
.section-form-item + .section-form-title-second {
    margin-top: 8px;
}
.blod {
    font-weight: 600;
}
.contract-added {
    color: var(--color_text_primary);
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: "PingFang SC";
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}
.contract-added-desc {
    color: var(--color_text_tertiary);
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: "PingFang SC";
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-top: 20px;
}
.attachment + .attachment {
    margin-top: 10px;
}

</style>